import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentAccountSelectionV2Data,
  type EnrollmentAccountSelectionV2SubmitOutput,
} from '../../../../../models'

export const getEnrollmentAccountSelectionV2DataMock: EnrollmentAccountSelectionV2Data = {
  __typename: 'SubmitEnrollmentSuccess',
  path: 'enrollment/investments/account-selection/',
  enrollmentData: {
    applicationId: '1234567890',
    userInfo: {
      investment: {
        canEnrollBrokerage: false,
        canEnrollRothIra: true,
        canEnrollTraditionalIra: true,
      },
    },
  },
}

export const submitEnrollmentAccountSelectionV2DataMock: EnrollmentAccountSelectionV2SubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/account-name/TRADITIONAL_IRA/',
}

export const mockGetEnrollmentAccountSelectionV2Data = graphql.mutation('getEnrollmentAccountSelectionV2Data', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentAccountSelectionV2DataMock } })
})

export const mockSubmitEnrollmentAccountSelectionV2Data = graphql.mutation(
  'submitEnrollmentAccountSelectionV2Data',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentAccountSelectionV2DataMock } })
  },
)

export const mockEnrollmentAccountSelectionV2 = [
  mockGetEnrollmentAccountSelectionV2Data,
  mockSubmitEnrollmentAccountSelectionV2Data,
]
